<template>
  <div style="height: 1500px">
    <a-row>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <h1 class="h1">Search</h1>
        <a-alert
          message="This page is used to quickly search and locate the relevant gene page according 
          to different classification. Please contact us to enrich this search page."
          type="success"
        />
      </a-col>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        style="margin-top: 30px"
      >
        <a-collapse default-active-key="1" :bordered="false" accordion>
          <template #expandIcon="props">
            <a-icon
              type="caret-right"
              :rotate="props.isActive ? 90 : 0"
              style="font-size: 25px"
            />
          </template>
          <a-collapse-panel
            key="1"
            header="Search by perturbed-genes"
            :style="customStyle"
          >
            <searchPerturbedgene />
          </a-collapse-panel>
          <a-collapse-panel
            key="2"
            header="Search by differentially expressed genes"
            :style="customStyle"
          >
            <searchdegene />
          </a-collapse-panel>
          <a-collapse-panel
            key="3"
            header="Search by potential target drug"
            :style="customStyle"
          >
          </a-collapse-panel>
          <a-collapse-panel
            key="4"
            header="Search by enrichment of functional pathway"
            :style="customStyle"
          >
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import searchPerturbedgene from "./search/perturbedgene.vue";
import searchdegene from "./search/degene.vue";

export default {
  components: { searchPerturbedgene, searchdegene },
  data() {
    return {
      formLayout: "horizontal",
      customStyle:
        "background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden;font-size:25px;line-height:25px",
    };
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
</style>
